<template>
  <ul class="more-info">
    <li
      class="more-info-item"
      v-for="(classification, index) in displayedClassifications"
      :key="classification.id"
    >
      <i class="icon">
        <img :src="getSrc" alt="icon" v-if="index < mainClassifications.length"/>
      </i>
      <div>
        <p class="subject-type">
          {{ title(classification.classificationsIndex) }}
          <p class="subject">
            {{ values(index) }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import { getClassificationIcon } from '@/utilityFunctions'
import { mapState } from 'vuex'
export default {
  name: 'classification-entery',
  props: {
    classifications: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      mainClassifications: state => state.classifications.classifications
    }),
    displayedClassifications () {
      const arr = []
      let i = 0
      while (i < this.mainClassifications.length) {
        const result = this.classifications.filter(e => {
          return e.key === this.mainClassifications[i].title
        })
        if (result.length) {
          const values = result.map(r => {
            return r.value
          })
          arr.push({ classificationsIndex: i, values: values })
        }
        i += 1
      }
      return arr
    },
    getSrc () {
      return getClassificationIcon(this.classifications.key)
    }
  },
  methods: {
    values (index) {
      if (index >= this.displayedClassifications.length) { return }
      let str = ''
      for (let i = 0; i < this.displayedClassifications[index].values.length; i++) {
        if (i === this.displayedClassifications[index].values.length - 1) {
          str += this.displayedClassifications[index].values[i]
          return str
        } else {
          str += this.displayedClassifications[index].values[i] + ', '
        }
      }
      return str
    },
    title (index) {
      if (index >= this.mainClassifications.length) { return }
      return this.mainClassifications[index].title
    }
  }
}
</script>

<style>

</style>
